import config from '../config.json'

export const clinicTypes = {
  MENTAL: 'mental',
  PRIMARY: 'primary',
  HTN: 'hypertension',
  DIABETES: 'diabetes',
}
export const clinicTypesShort = {
  mental: 'MH',
  primary: 'PRIMARY',
  hypertension: 'HTN',
  diabetes: 'DM',
}

export const HMOService = 'HMO'

export const referralClinicTypes = {
  antiDoteReferrals: 6,
}

export const clinicActions = {
  primary: {
    cancel: {
      initial: {
        isVisible: true,
        isAllow: true,
        alertKey: 'cancelAlertPrimary',
      },
      followup: { isVisible: true, isAllow: true },
    },
    rescedule: {
      initial: { isVisible: true, isAllow: true },
      followup: { isVisible: true, isAllow: true },
    },
  },
  mental: {
    cancel: {
      initial: { isVisible: true, isAllow: true, alertKey: 'cancelAlert' },
      followup: {
        isVisible: true,
        isAllow: false,
        alertKey: 'supportCancelAlert',
      },
    },
    rescedule: {
      initial: { isVisible: true, isAllow: true },
      followup: {
        isVisible: true,
        isAllow: false,
        alertKey: 'supportResceduleMessage',
      },
    },
  },
  hypertension: {
    cancel: {
      initial: { isVisible: true, isAllow: true, alertKey: 'cancelAlert' },
      followup: { isVisible: true, isAllow: false, alertKey: 'cancelFUAlert' },
    },
    rescedule: {
      initial: { isVisible: true, isAllow: true },
      followup: { isVisible: false, isAllow: false },
    },
  },
  diabetes: {
    cancel: {
      initial: { isVisible: true, isAllow: true, alertKey: 'cancelAlert' },
      followup: { isVisible: true, isAllow: false, alertKey: 'cancelFUAlert' },
    },
    rescedule: {
      initial: { isVisible: true, isAllow: true },
      followup: { isVisible: false, isAllow: false },
    },
  },
  primaryHMO: {
    cancel: {
      initial: {
        isVisible: true,
        isAllow: true,
        alertKey: 'cancelAlertPrimary',
      },
      followup: { isVisible: true, isAllow: true },
    },
    rescedule: {
      initial: { isVisible: true, isAllow: true },
      followup: { isVisible: true, isAllow: true },
    },
  },
}

export const getClinicImage = clinic => {
  const image_name = clinic === clinicTypes.HTN ? 'htn' : clinic
  return {
    uri: config.gcpStorageUrl + '/Clinics/' + image_name + '.svg',
  }
}
